import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Provider as ReduxProvider } from 'react-redux';
import { Persistor, persistStore } from 'redux-persist'
import { useAPI } from "../../apiv1";
import { logout, RejectionReason } from "../../store/slices/session";
import { newStore, Store } from "../../store/store";
import { PersistGate } from "redux-persist/integration/react";

export type ReduxProps = {
	children?: React.ReactNode;
}

export default function Redux(props: ReduxProps) {
	const api = useAPI();
	const navigate = useNavigate();
	const storeRef = useRef<Store>();
	const persistorRef = useRef<Persistor>();

	if (storeRef.current === undefined || persistorRef.current === undefined) {
		storeRef.current = newStore(api, navigate);

		api.onUnauthorized(() => {
			if (storeRef.current === undefined) {
				throw new Error("storeRef.current may not be undefined");
			}
			storeRef.current.dispatch(logout(RejectionReason.ExternalLogout));
		});

		persistorRef.current = persistStore(storeRef.current);
	}

	return <ReduxProvider store={storeRef.current}>
		<PersistGate persistor={persistorRef.current}>
			{props.children}
		</PersistGate>
	</ReduxProvider>
}
